export default __webpack_public_path__ + "static/media/contactbanner.bc655707.jpg";